<avn-form-field>
  <avn-input [type]="'number'" [label]="labelKey$ | async | transloco" [showSpinButtonsForNumberInput]="true" [formControl]="numeric"> </avn-input>
  <avn-form-field-hint [message]="'alarmEvents.CUSTOM_PICKER.NUMERIC_VALUE.MESSAGE' | transloco"></avn-form-field-hint>
</avn-form-field>
